import request from './_config'

const path = `report`

export function getReportCampaigns(tiktokAccountId, params) {
    return request({
        url: `${path}/get/${tiktokAccountId}`,
        method: 'get',
        params
    })
}

export function getReportFromTTA(tiktokAccountId, params) {
    return request({
        url: `${path}/get_from_tta/${tiktokAccountId}`,
        method: 'get',
        params
    })
}

export function getOverviewMulti(tiktokAccountId, data) {
    return request({
        url: `${path}/over_view_multi/${tiktokAccountId}`,
        method: 'post',
        data
    })
}

export function getReportOverview(tiktokAccountId, params) {
    return request({
        url: `${path}/over_view/${tiktokAccountId}`,
        method: 'get',
        params: {
            order_field: params.order_field,
            order_type: params.order_type,
            start_date: params.start_date,
            end_date: params.end_date,
            advertiser_id: params.advertiser_id,
            report_type: 'BASIC',
            filtering: JSON.stringify(params.filtering),
            metrics: JSON.stringify([
                'spend',
                'cpc',
                'impressions',
                'cpm',
                'cost_per_conversion',
                'clicks',
                'conversion_rate',
                'ctr',
                'conversion'
            ])
        }
    })
}

export function getConfigAdsLives(tiktokAccountId, params) {
    return request({
        url: `${path}/config_watch_ads_live/${tiktokAccountId}`,
        method: 'get',
        params: {
            advertiser_id: params.advertiser_id,
            campaign_ids: params.campaign_ids
        }
    })
}

export function setConfigAdsLive(tiktokAccountId, data) {
    return request({
        url: `${path}/config_watch_ads_live/${tiktokAccountId}`,
        method: 'post',
        data: {
            advertiser_id: data.advertiser_id,
            campaign_ids: data.campaign_ids,
            start_time: data.start_time,
            end_time: data.end_time,
            config_list: data.config_list,
            status: data.status
        }
    })
}

export function deleteConfigAdsLive(tiktokAccountId, data) {
    return request({
        url: `${path}/delete_config_watch_ads_live/${tiktokAccountId}`,
        method: 'post',
        data: {
            advertiser_id: data.advertiser_id,
            campaign_ids: data.campaign_ids
        }
    })
}

export function exportExcel(tiktokAccountId, params) {
    return request({
        url: `${path}/export_excel/${tiktokAccountId}`,
        method: 'get',
        params,
        responseType: 'blob'
    })
}
